import { z } from 'zod';

export const FilterConditionsModel = z.record(z.string());
